import type {Plugin} from 'vue';

import IconAddUpload from 'assets/svgs/addUpload.svg';
import IconArrowRight from 'assets/svgs/arrowRight.svg';
import IconAttachment from 'assets/svgs/attachment.svg';
import IconClose from 'assets/svgs/close.svg';
import IconDelete from 'assets/svgs/delete.svg';
import IconFailure from 'assets/svgs/failure.svg';
import IconForkClose from 'assets/svgs/forkClose.svg';
import IconHomeLogo from 'assets/svgs/homeLogo.svg';
import IconLogo from 'assets/svgs/logo.svg';
import IconMore from 'assets/svgs/more.svg';
import IconNextQuestion from 'assets/svgs/nextQuestion.svg';
import IconPervQuestion from 'assets/svgs/pervQuestion.svg';
import IconSelectArrow from 'assets/svgs/selectArrow.svg';
import IconSuccess from 'assets/svgs/success.svg';
import IconTicFooter from 'assets/svgs/ticFooter.svg';
import IconUpload from 'assets/svgs/upload.svg';
const iconsInstall: Plugin = (app) => {
    app.component('IconAddUpload', IconAddUpload);
    app.component('IconArrowRight', IconArrowRight);
    app.component('IconAttachment', IconAttachment);
    app.component('IconClose', IconClose);
    app.component('IconDelete', IconDelete);
    app.component('IconFailure', IconFailure);
    app.component('IconForkClose', IconForkClose);
    app.component('IconHomeLogo', IconHomeLogo);
    app.component('IconLogo', IconLogo);
    app.component('IconMore', IconMore);
    app.component('IconNextQuestion', IconNextQuestion);
    app.component('IconPervQuestion', IconPervQuestion);
    app.component('IconSelectArrow', IconSelectArrow);
    app.component('IconSuccess', IconSuccess);
    app.component('IconTicFooter', IconTicFooter);
    app.component('IconUpload', IconUpload);
};
export default iconsInstall;
